/**
 * Newsletter Validation Schemas for AmalQ
 * Zod validation schemas for newsletter subscription
 * Following enterprise-grade validation patterns
 */

import { z } from 'zod';

/**
 * Newsletter Subscription Validation Schema
 * Validates email subscription requests with comprehensive error messages
 */
export const newsletterSubscribeSchema = z.object({
  email: z
    .string()
    .min(1, 'Email address is required')
    .email('Please enter a valid email address')
    .max(255, 'Email address must be less than 255 characters')
    .toLowerCase()
    .trim()
    .refine(
      (email) => {
        // Additional validation: ensure email has proper format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },
      {
        message: 'Please enter a valid email address format',
      }
    )
    .refine(
      (email) => {
        // Prevent common invalid patterns
        return !email.startsWith('.') && !email.endsWith('.');
      },
      {
        message: 'Email address cannot start or end with a period',
      }
    )
    .refine(
      (email) => {
        // Prevent consecutive dots
        return !email.includes('..');
      },
      {
        message: 'Email address cannot contain consecutive periods',
      }
    ),
});

/**
 * Type inference for newsletter subscription form data
 */
export type NewsletterSubscribeFormData = z.infer<typeof newsletterSubscribeSchema>;

